import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_EVENTS ({ commit }, search) {
    const isnum = /^\d+$/.test(search)
    let searchFilter
    if (isnum) {
      searchFilter = {
        field_001: { eq: Number(search) },
        onlinestatusJoin: { neq: '2' }
      }
    } else {
      searchFilter = {
        or: [{ eventlisttitleDE: { contains: search } },
             { eventlisttitleEN: { contains: search } }],
        onlinestatusJoin: { neq: '2' }
      }
    }

    const query = `query events (
      $order: [CrmEventSortInput!]
      $where: CrmEventFilterInput
    ) {
      response: events (order: $order, where: $where) {
        field_001
        eventlisttitleDE
        eventlisttitleEN
        onlinestatusJoin
        eventpool {
          thema_en
        }
      }
    }`

    const variables = {
      where: searchFilter
    }

    commit('SET_EVENTS', [])
    const { data } = await gql({ query, variables })
      if (!data.errors) {
        const eventArray = []
        for (const event of data.data.response) {
          event.combinedField = `(${event.field_001}) ` + (event.eventlisttitleEN ? event.eventlisttitleEN : (event.eventlisttitleDE ? event.eventlisttitleDE : (event.eventpool.thema_en ? event.eventpool.thema_en : '')))
          eventArray.push(event)
        }
        commit('SET_EVENTS', eventArray)
      }
    },

    async GET_EVENT ({ commit }, eventId) {
      const query = `query event ($id: Int!) {
        response: event (field_001: $id) {
          field_001
          min_registrations
          min_confirmed
          min_doc_submitted
        }
      }`

      const variables = {
        id: Number(eventId)
      }

      const { data } = await gql({ query, variables })
      return data.data.response
    },

    async CREATE_QUICKLINKS ({ commit }, formData) {
      const {
        name,
        url
      } = formData

        const query = `mutation createEvent_Dashboard_Quicklink($input: CreateEvent_Dashboard_QuicklinkInput!) {
          response: createEvent_Dashboard_Quicklink(input: $input) {
            event_Dashboard_Quicklink {
              field_001,
              userId,
              name,
              url
            }
            errors {
              code
              message
              i18nKey
              field
            }
          }
        }
        `

        const variables = {
          input: {
            name,
            url
          }
        }

        const { data } = await gql({ query, variables })

        return data.data.response
    },

    async GET_QUICKLINKS ({ commit }) {
      const query = `query event_Dashboard_Quicklinks (
        $order: [Event_Dashboard_QuicklinkSortInput!]
        $where: Event_Dashboard_QuicklinkFilterInput
      ) {
        response: event_Dashboard_Quicklinks (order: $order, where: $where) {
          field_001
          name
          url
        }
      }`

      const variables = {
        order: {
          name: 'ASC'
        }
      }

      const { data } = await gql({ query, variables })
        if (!data.errors) {
          commit('SET_QUICKLINKS', data.data.response)
        }

        return data
    },

    async DELETE_QUICKLINK ({ commit }, quicklinkId) {
      const query = `mutation deleteEvent_Dashboard_Quicklink($field_001: Int!) {
        deleteEvent_Dashboard_Quicklink(field_001: $field_001) {
          ok
          errors {
            code
            message
            i18nKey
            field
          }
        }
      }`

      const variables = {
        field_001: quicklinkId
      }

      const { data } = await gql({ query, variables })

      return data.data.deleteEvent_Dashboard_Quicklink
    },

    async CREATE_EVENT_OWNER ({ commit }, eventId) {
        const query = `mutation createEvent_Dashboard_Owner($input: CreateEvent_Dashboard_OwnerInput!) {
          response: createEvent_Dashboard_Owner(input: $input) {
            event_Dashboard_Owner {
              field_001,
              userId,
              eventId
            }
            errors {
              code
              message
              i18nKey
              field
            }
          }
        }
        `

        const variables = {
          input: {
            eventId
          }
        }

        const { data } = await gql({ query, variables })
        return data.data.response
    },

    async GET_DASHBOARDEVENTS ({ commit }) {
      const query = `query event_Dashboard_Owners (
        $order: [Event_Dashboard_OwnerSortInput!]
        $where: Event_Dashboard_OwnerFilterInput
      ) {
        response: event_Dashboard_Owners (order: $order, where: $where) {
          field_001
          eventId
          crmEvent {
            eventlisttitleDE
            eventlisttitleEN
            min_registrations
            min_confirmed
            min_doc_submitted
            sortierdatum
            vlabApplicationDeadline
            event_art_id
            course_no
            eventpool {
              thema_en
            }
            cRMAnmeldungBestellungen {
              field_001
              eventID
              eventSignupAffirmIDId
              crm_adresse_id
              cRMAddress {
                field_001
                salutationId
                kantonId
                unispinoffId
                cRMAdresseJOINRolles {
                  crm_adress_id
                  rolle_id
                }
              }
            }
          }
        }
      }`

      const variables = {
        order: {
          field_001: 'ASC'
        }
      }

      const { data } = await gql({ query, variables })
      if (!data.errors) {
        commit('SET_DASHBOARDEVENTS', data.data.response)
      }

      return data
    },

    async UPDATE_EVENT ({ commit }, formData) {
      const {
        eventId,
        minReg,
        minConf,
        minDocSubmitted
      } = formData

      const query = `mutation updateEvent ($input: UpdateEventInput) {
        updateEvent(input: $input) {
          crmEvent {
            field_001
          }
          errors {
            code
            message
            i18nKey
            field
          }
        }
      }`

      const variables = {
        input: {
          field_001: Number(eventId),
          min_registrations: Number(minReg),
          min_confirmed: Number(minConf),
          min_doc_submitted: Number(minDocSubmitted)
        }
      }

      const { data } = await gql({ query, variables })

      return data
    },

    async DELETE_OWNER ({ commit }, ownerId) {
      const query = `mutation deleteEvent_Dashboard_Owner($field_001: Int!) {
        deleteEvent_Dashboard_Owner(field_001: $field_001) {
          ok
          errors {
            code
            message
            i18nKey
            field
          }
        }
      }`

      const variables = {
        field_001: ownerId
      }

      const { data } = await gql({ query, variables })

      return data.data.deleteEvent_Dashboard_Owner
    },
    async GET_OWNERS_BY_EVENTID ({ commit }, eventId) {
      const query = `query event_Dashboard_AllOwners (
        $order: [Event_Dashboard_OwnerSortInput!]
        $where: Event_Dashboard_OwnerFilterInput
      ) {
        response: event_Dashboard_AllOwners (order: $order, where: $where) {
          field_001
          eventId
          userId
        }
      }`

      const variables = {
        where: {
          eventId: { eq: eventId }
        }
      }

      const { data } = await gql({ query, variables })
      if (!data.errors) {
        commit('SET_OWNERS_BY_EVENTID', data.data.response)
      }

      return data
    },

    async CREATE_EVENT_OTHER_OWNER ({ commit }, formData) {
      const {
        eventId,
        userId
      } = formData
      const query = `mutation createEvent_Dashboard_AllOwner($input: CreateEvent_Dashboard_AllOwnerInput!) {
        response: createEvent_Dashboard_AllOwner(input: $input) {
          event_Dashboard_Owner {
            field_001,
            userId,
            eventId
          }
          errors {
            code
            message
            i18nKey
            field
          }
        }
      }
      `

      const variables = {
        input: {
          eventId,
          userId
        }
      }

      const { data } = await gql({ query, variables })
      return data.data.response
  }
}
